import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-marketing',
  templateUrl: './admin-marketing.component.html',
  styleUrls: ['./admin-marketing.component.scss']
})
export class AdminMarketingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
